import {inject, Injectable, OnDestroy} from "@angular/core";
import {Messaging, getToken,getMessaging ,onMessage} from "@angular/fire/messaging";
import {BehaviorSubject} from "rxjs";
import {environment} from "../../../../environments/environment";
import {AngularFireMessaging} from "@angular/fire/compat/messaging";

@Injectable({
  providedIn: 'root'
})

export class FcmService implements OnDestroy {
  private messageSubject = new BehaviorSubject<any>(null);
  message$ = this.messageSubject.asObservable();

  constructor(private afMessaging: AngularFireMessaging) {}

  requestPermission(): void {
    this.afMessaging.requestToken.subscribe(
      (token) => {
        console.log('FCM Token:', token);
        // Gửi token lên server nếu cần
      },
      (error) => {
        console.error('Error getting token:', error);
      }
    );
  }

  receiveMessage(): void {
    this.afMessaging.messages.subscribe(
      (payload) => {
        console.log('Foreground message:', payload);
        // Xử lý thông báo foreground
      }
    );
  }

  ngOnDestroy() {
    // Cleanup nếu cần
  }
}
